import React, { useEffect, useState } from 'react';
import { Button, Table } from 'antd';
import { useHistory } from 'react-router-dom';
import { manageenrolledstudent } from 'adminRoutes';
import useCurrencyFormater from 'components/hooks/useCurrencyFormater';

const CourseInsightsOverviewTable = ({
  insightResult,
  currentPage,
  pageSize,
  setCurrentPage,
  setPageSize,
  toggleExport
}) => {
  const history = useHistory();
  const [pagination, setPagination] = useState();
  const currencyFormatter = useCurrencyFormater();

  useEffect(() => {
    if (!toggleExport) {
      setPagination({
        current: currentPage,
        pageSize: pageSize,
        total: insightResult?.data[0]?.totalRows
      });
    }
  }, [insightResult, currentPage, pageSize, toggleExport]);

  const columns = [
    {
      title: 'S/NO',
      dataIndex: 'sno',
      key: 'sno'
    },
    {
      title: 'PARTNER',
      dataIndex: 'institution',
      key: 'institution',
      render: text => <p>{text?.toUpperCase()}</p>
    },
    {
      title: 'COURSE NAME',
      dataIndex: 'courseName',
      key: 'courseName',
      render: text => <p style={{ color: '#1890ff' }}>{text}</p>
    },
    {
      title: 'ENROLLED USERS',
      dataIndex: 'noOfEnrolledUser',
      key: 'enrolledUsers'
    },
    {
      title: 'TOTAL REVENUE',
      dataIndex: 'totalRevenue',
      key: 'totalRevenue'
    },
    {
      title: 'TOTAL DISCOUNT',
      dataIndex: 'totalDiscount',
      key: 'totalDiscount'
    },
    {
      title: 'RIVET REVENUE',
      dataIndex: 'partnerRevenue',
      key: 'partnerRevenue'
    },
    {
      title: 'PARTNER REVENUE',
      dataIndex: 'institutionRevenue',
      key: 'totalRevenue'
    },
    {
      title: 'VAT',
      dataIndex: 'totalVat',
      key: 'totalVat'
    },
    {
      title: 'GATEWAY CHARGE',
      dataIndex: 'totalGatewayCharge',
      key: 'totalGatewayCharge'
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (text, record) => (
        <Button
          onClick={() => {
            history.push(
              manageenrolledstudent.replace('/:manageenrolledstudent', `/${record.courseId}`),
              {
                record,
                insightOverview: 'insightOverview'
              }
            );
          }}>
          View
        </Button>
      )
    }
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };
  const tableData = insightResult?.data?.map((item, i) => ({
    ...item,
    key: i,
    totalRevenue: currencyFormatter('NGN', 'en-NG', item.totalRevenue),
    partnerRevenue: currencyFormatter('NGN', 'en-NG', item.partnerRevenue),
    institutionRevenue: currencyFormatter('NGN', 'en-NG', item.institutionRevenue),
    totalVat: currencyFormatter('NGN', 'en-NG', item.totalVat),
    totalGatewayCharge: currencyFormatter('NGN', 'en-NG', item.totalGatewayCharge),
    totalDiscount: currencyFormatter('NGN', 'en-NG', item.totalDiscount)
  }));
  return (
    <Table
      style={{ width: '100%', overflow: 'auto' }}
      columns={columns}
      dataSource={tableData}
      pagination={pagination}
      onChange={handleTableChange}
    />
  );
};

export default CourseInsightsOverviewTable;
